import { useContext } from "react";
import contextBabylon from "../../../../../context/index.js";
import { useSubmitWithRedirect } from "../../../../../hooks/common/searchers/submit/useSubmitWithRedirect.js";
import { buildUrl } from "../utils/url.js";
import useSearcherActivitiesDefaultValues from "./useSearcherActivitiesDefaultValues.js";
const useSearcherActivitiesForm = (props)=>{
    const { BaseUrl =''  } = useContext(contextBabylon);
    const { urlResults ='/actividades/resultados' , urlDetail ='/actividades/detalle' , testToken =''  } = props ?? {};
    const handleOnSubmit = (values)=>{
        const results = urlResults.startsWith('http') ? urlResults : `${BaseUrl}${urlResults}`;
        const detail = urlDetail.startsWith('http') ? urlDetail : `${BaseUrl}${urlDetail}`;
        const baseUrl = values.destination.type === 'ACT' ? detail : results;
        const finalUrl = buildUrl(baseUrl, {
            ...values,
            testToken
        });
        window.location.assign(finalUrl);
    };
    const { isRedirecting , onSubmit  } = useSubmitWithRedirect(handleOnSubmit);
    return {
        onSubmit,
        isRedirecting,
        defaultValues: useSearcherActivitiesDefaultValues(props)
    };
};
export default useSearcherActivitiesForm;

//# sourceMappingURL=useSearcherActivitiesForm.js.map